import { Subscription } from 'rxjs';
import { DragulaService } from 'ng2-dragula';
import { GeomSymsService } from './../../services/geom-syms.service';
import { LabelStyle } from './../../types/LabelStyle';
import { HexString } from './../../types/@types/hex-string.d';
import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { TreeModel, TreeNode, TREE_ACTIONS, ITreeOptions, TreeComponent } from '@circlon/angular-tree-component';
import { ClassificationService } from 'src/app/model/api-services/classification.service';
import { ColorClassification } from 'src/app/types/color-classification';
import { ColorClass } from 'src/app/types/color-class';
import { Decorable } from 'src/app/types/decorable';
import { SLLayer } from 'src/app/model/sl-layer';
import * as _ from 'lodash';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { ColorGenDialogService } from '../dialogs/color-gen-dialog/color-gen-dialog.service';
import { v4 as uuid } from 'uuid';
import dragula from 'dragula';
import { json } from 'd3';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { CustomSymbolDialogService } from '../dialogs/custom-symbol-dialog/custom-symbol-dialog.service';

export type ClassColorRule = {
  crid: number;
  description: string;
  fill: string;
  labelStyle: LabelStyle;
  priority: number;
  size: number | string;
  stroke: HexString;
  symbol: string;
  useFill: boolean;
  useLabelStyle: boolean;
  useStroke: boolean;
  field: string;
  operator: string;
  value: any;
}

export type ClassCriteriaDisplayData = {
  crid: number;
  hasChildren: boolean;
  isExpanded: boolean;
  name: string;
  rule?: ClassColorRule;
  children?: Array<ClassCriteriaDisplayData>;
  field: string;
  operator: string;
  value: any;
}

export type ClassificationData = [{
  crid: -1;
  hasChildren: true;
  isExpanded: true;
  name: 'Layer Styles';
  children: Array<ClassCriteriaDisplayData>;
}]



@Component({
  selector: 'app-classification-view',
  templateUrl: './classification-view.component.html',
  styleUrls: ['./classification-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClassificationViewComponent implements OnInit {

  @Input() layer: SLLayer;
  @Input() geom = 'point';
  @Input() name = 'Layer Styles';
  @Input() groupName = 'Style Criteria';
  @Input() groupItemName = 'Style Definition';
  @Input() autoLoad = 'false';
  @ViewChild('tree', { static: true }) tree: TreeComponent;

  public nodes: ClassificationData = [{ crid: -1, hasChildren: true, isExpanded: true, children: [], name: 'Layer Styles' }];
  public nextClassId = 0;
  public nextStyleId = 0;
  public classification: ColorClassification;
  public descriptions: Decorable = {};
  public priorities: Decorable = {};
  public element: ElementRef;
  private activeNodeInfo: any = { nodeId: -1, hasChildren: false };
  public hasActiveNode = false;
  private _ready = false;
  private lookup: any = {};
  /*public treeOptions: ITreeOptions = {
    allowDrag: true,
    idField: 'crid',
    scrollOnActivate: false,
    actionMapping: {
      mouse: {
        dragStart: (tree: TreeModel, node: TreeNode, $event: any, ...rest: any) => {

          node = node;
          rest = rest;
          tree = tree;
          const element = document.elementFromPoint($event.pageX, $event.pageY);
          // if(element.tagName === 'input') return true;
          if ($(element).hasClass('grip') === false) {
            if (!!$event.stopImmediatePropagation) {
              $event.stopImmediatePropagation();
            }
            if (!!$event.stopPropagation) {
              $event.stopPropagation();
            }
            if (!!$event.preventDefault) {
              $event.preventDefault();
              $event.preventDefault = true;
            }
            if (!!$event.cancelBubble) {
              $event.cancelBubble = true;
            }
            return false;
          }
        },
        drop: (tree: TreeModel, node: TreeNode, $event: any, { from, to }) => {

          if (!!to.parent.data.virtual) {
            // trying to add to root
            return;
          }
          if (to.parent.data.crid === -1) {
            // dropping on/in "Color Rules" node
            if (from.data.crid === -1) { return; }
            if (!!from.data.crid.virtual) { return; }
            if (from.data.hasChildren === false) { return; }
          }
          if (to.parent.data.hasChildren === true) {
            // dropping on group
            if (from.data.hasChildren === true) {
              if (from.parent.data.crid === -1) {
                if (to.parent.data.crid !== -1) {
                  return;
                }
              }
            }
          }
          if (to.parent.data.hasChildren === false) {
            if (!!to.dropOnNode) {
              if (to.dropOnNode === true) {
                return;
              }
            }
            if (from.data.hasChildren === true) {
              return;
            }
          }

          // tslint:disable-next-line: object-literal-key-quotes

          // use from to get the dragged node.
          // use to.parent and to.index to get the drop location
          // use TREE_ACTIONS.MOVE_NODE to invoke the original action

          if (from.data.hasChildren === false) {
            if (from.parent.data.crid === to.parent.data.crid) {
              TREE_ACTIONS.MOVE_NODE(tree, node, $event, { from, to });

              return;
            } else {
              this.messager.Confirm(
                'Are you sure you want to move this criteria to another style definition?',
                () => {
                  TREE_ACTIONS.MOVE_NODE(tree, node, $event, { from, to });
                  node.data.children[0].rule.description = to.parent.data.crid;
                  node.data.name = node.data.name.split(':').shift() + ':' + to.parent.data.crid;
                  return;
                }, () => { }, 'Criteria move confirmation');
            }
          } else {
            TREE_ACTIONS.MOVE_NODE(tree, node, $event, { from, to });
            node.data.children[0].rule.description = to.data.crid;
            node.data.name = node.data.name.split(':').shift() + ':' + to.parent.data.crid;
          }
        }
      }
    }
  };
  */
  private otherNode: Decorable;
  private addedCrid = -1;
  private subs = new Subscription();
  public modified = false;
  constructor(
    private domNode: ElementRef,
    private classes: ClassificationService,
    private messager: ModalMessagerService,
    private colorGenService: ColorGenDialogService,
    private syms: GeomSymsService,
    private cdr: ChangeDetectorRef,
    private dragulaSvc: DragulaService,
    private customSymbols: CustomSymbolDialogService) {
    this.element = this.domNode.nativeElement;

    if (this.autoLoad === 'true') {
      this.classes.GetProjectClasses(13413).then((classification: ColorClassification) => {
        classification = null;
      });
    }
  }
  Select(node: any, event?: any) {

    if (event) {
      if (event.target.nodeName.toLowerCase() !== 'div') return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    this.activeNodeInfo = node;
    this.hasActiveNode = true;
    this.cdr.markForCheck();
    this.Refresh();
  }
  ngOnInit() {
    const classes = this.dragulaSvc.createGroup('CLASSIFICATIONS', {
      moves: (el?: Element, container?: Element, handle?: Element) => {
        return handle?.classList.contains('class-grip') === true;
      },
      accepts: (el?, target?, source?, sibling?) => {
        return target.classList.contains('classifications');
      }
    })
    const styles = this.dragulaSvc.createGroup('STYLES', {
      moves: (el?: Element, container?: Element, handle?: Element) => {
        return handle?.classList.contains('style-grip') === true;
      },
      accepts: (el?, target?, source?, sibling?) => {
        return target.classList.contains('styles');
      },
      copy: false,
      copyItem(item: any): any {
        return JSON.parse(JSON.stringify(item));
      }
    });
    this.subs.add(this.dragulaSvc.drop('STYLES').subscribe(({ el, target, source, sibling }) => {
      console.log('dropped');
      console.log(el, target, source, sibling);
    }));
    this._ready = true;
    if (!!this.layer) {
      this.geom = this.layer.geom;
      this.ShowClass(this.layer);
    }

  }
  ShowClass(layer: SLLayer) {
    this.activeNodeInfo.id = -1;
    this.activeNodeInfo.hasChildren = false;
    this.layer = layer;
    this.geom = this.layer.geom;
    this.classes.GetProjectClasses(Number(this.layer.plid)).then((classification: ColorClassification) => {
      this.classification = classification;
      this.SetNodes();
      window.requestAnimationFrame(() => {
        this.modified = false;
        this.Refresh();
      });
    });
  }
  Revert() {
    this.ShowClass(this.layer);
  }
  SetNodes() {
    this.nodes[0].children = [];
    // this.tree.treeModel.update();
    this.descriptions = {};
    this.priorities = {};
    this.addedCrid = -1;
    let classPriority = 1;
    this.lookup = {};

    // const crit: any = {};
    for (const colorClass of this.classification.classes) {
      colorClass.priority = classPriority;
      classPriority = classPriority + 1;
      if (colorClass.description === undefined) {
        colorClass.description = '';
      }
      if (colorClass.description === null) {
        colorClass.description = '';
      }
      if (!this.descriptions.hasOwnProperty(colorClass.description)) {
        this.descriptions[colorClass.description] = {
          children: [colorClass]
        };
      } else {
        this.descriptions[colorClass.description].children.push(colorClass);
      }
      this.priorities[colorClass.priority] = colorClass.description;
    }

    let lastDescription = null;
    for (const priority in this.priorities) {
      if (!this.priorities.hasOwnProperty(priority)) { continue; }
      const node: Decorable = {};

      const description = this.priorities[priority];
      if (lastDescription === description) {
        continue;
      } else {

        node.crid = description;
        node.name = description;
        this.lookup[node.crid] = node;
        node.isExpanded = true;
        if (node.name === '') {
          node.name = 'All other features';
        }
        node.hasChildren = true;
        node.children = [];
        node.parent = this.nodes[0];

        if (this.descriptions[description].children.length > 0) {
          const firstChild = this.descriptions[description].children[0];
          node.value = firstChild.value;
          node.field = firstChild.field;
          node.operator = firstChild.operator;
        } else {
          node.field = 'null';
          node.value = '';
          node.operator = '';
        }
        for (const child of this.descriptions[description].children) {
          const rule = child as ColorClass;
          rule.useFill = rule.fill !== 'trans';
          rule.useStroke = rule.stroke !== 'trans';
          rule.useLabelStyle = rule.labelStyle !== '';
          node.children.push({ crid: child.crid, rule: child, hasChildren: false, isExpanded: true, parent: node, name: 'rule:' + child.description });

        }
        this.nodes[0].children.push(node as ClassCriteriaDisplayData);
        lastDescription = description;
      }
    }
    console.log(this.nodes);
    this.Refresh();
    // this.tree.treeModel.update();
    /// this.tree.treeModel.expandAll();
  }
  EditCustom(symbol,styleNode) {
    this.customSymbols.Edit(symbol,(size: string) => {
      styleNode.rule.size = size;
      this.cdr.markForCheck();
      this.Refresh();
    })
  }
  HandleViewChange() {

  }
  HandleToggle(event: any) {
    event = null;
  }
  DeleteSelected() {
    if (!this.hasActiveNode) return;
    this.modified = true;
    this.DeleteNode(this.activeNodeInfo);
    this.activeNodeInfo = undefined;
    this.Refresh();
  }
  DeleteNode(node: any) {
    const hasChildren = node.hasChildren;
    const message = 'Are you sure you want to delete the current ' + ((hasChildren === true) ? 'style defintion?' : 'style criteria?	');
    this.messager.Confirm(message, () => {
      const parent = (!!node.parent) ? node.parent : this.nodes[0]

      _.remove(parent.children, (child: any) => {
        return child.crid === node.crid;
      });

      // this.tree.treeModel.update();
      if ((parent as any).crid !== -1) {
        if (node.parent.children.length === 0) {
          node.parent.hasChildren = false;
        }
      }
      this.Refresh();

    }, () => { }, 'Are you sure');

  }
  UpdateClasses() {
    this.classification.classes = [];
    let z = 1;
    for (const node of this.nodes[0].children) {
      for (const child of node.children) {
        const rule: ClassColorRule = child.rule;
        rule.priority = z;
        z++;
        rule.description = node.name;
        if (rule.useFill === false) {
          rule.fill = 'trans';
        }
        if (rule.useStroke === false) {
          rule.stroke = 'trans';
        }
        if (rule.useLabelStyle === false) {
          rule.labelStyle = '';
        }
        this.classification.classes.push(rule as ColorClass);
      }
    }

  }

  CreateRule(focusNode: TreeNode = null) {
    this.modified = true;
    let focusedNode: Decorable = (!!focusNode) ? focusNode : this.activeNodeInfo;
    if (!!focusNode) {
      focusedNode = focusNode as TreeNode;
    }
    let i = 0;
    let node: Decorable = { field: '', operator: '', value: '' };
    this.addedCrid -= 1;
    if (!!focusedNode) {
      if (focusedNode.parent.crid === this.nodes[0].crid) {
        if ((focusedNode as Decorable).crid === this.addedCrid) {
          node = focusedNode;
        } else {
          node = focusedNode;

          node.children.push(
            {
              crid: this.addedCrid,
              rule: ({
                id: this.nextStyleId,
                crid: this.addedCrid,
                description: focusedNode.name,
                field: focusedNode.field,
                useFill: false,
                fill: 'trans',
                labelStyle: '',
                useLabelStyle: false,
                operator: focusedNode.operator,
                priority: -1,
                size: 2,
                stroke: 'trans',
                useStroke: false,
                symbol: '',
                value: focusedNode.value

              } as ColorClass),
              hasChildren: false,
              name: 'rule:' + focusedNode.name,
              parent: focusedNode
            });
          this.nextStyleId += 1;
          this.Refresh();
          return;
        }
      } else {
        i = this.nodes[0].children.indexOf(focusedNode.parent) + 1;
        node = focusedNode.parent;
      }
    } else {
      this.messager.Notify('To add a new style definition you must first either select either an existing style criteria, or style definition in an existing style criteria group. ' +
        'If no criteria are available, you will need to add a new criteria group first.');
      return;
      // node = this.CreateOtherNode();
    }
    this.addedCrid -= 1;

    node.children.splice(i, 0,
      {

        crid: this.addedCrid,
        rule: ({
          id: this.nextStyleId,
          crid: this.addedCrid,
          description: node.name,
          field: node.field,
          useFill: false,
          fill: 'trans',
          labelStyle: '',
          useLabelStyle: false,
          operator: node.operator,
          priority: -1,
          size: 2,
          stroke: 'trans',
          useStroke: false,
          symbol: '',
          value: node.value

        } as ColorClass),
        hasChildren: false,
        name: 'rule:' + node.name,
        virtual: true,
        parent: focusedNode.parent
      }
    );
    this.nextStyleId += 1;
    this.Refresh();
  }
  CreateNewGroup() {
    this.addedCrid -= 1;
    const node: Decorable = {
      crid: this.addedCrid,
      name: 'New ' + this.groupName
    };
    node.hasChildren = true;
    node.children = [];
    node.parent = this.nodes[0];
    this.nodes[0].children.unshift(node as ClassCriteriaDisplayData);
    // this.tree.treeModel.update();
    const addedNode: Decorable = node;
    //this.tree.treeModel.setFocusedNode(addedNode);
    // addedNode.setActiveAndVisible(false);
    this.Refresh();
    this.Select(addedNode);
    this.CreateRule(addedNode as TreeNode);

    (addedNode as any).isExpanded = true;
    //this.tree.treeModel.update();
    // addedNode.scrollIntoView(true);


  }
  CreateOtherNode(): Decorable {
    if (!!this.otherNode) {
      return this.otherNode;
    }
    for (const item of this.nodes[0].children) {
      if (item.name === 'All other features') {
        this.otherNode = item;
        return this.otherNode;
      }
    }

    const node: Decorable = {
      crid: 'All other features',
      name: 'All other features'
    };
    node.hasChildren = true;
    node.children = [];
    this.nodes[0].children.push(node as ClassCriteriaDisplayData);
    this.otherNode = node;
    return this.otherNode;
  }
  ColorGenDialogClick() {
    this.colorGenService.Show((classification) => {
      this.classification = classification;
      this.SetNodes();
      this.modified = true;
      this.Refresh();
    }, this.layer, this.classification);
  }
  NodesToClasses() {
    this.classification.classes = [];
    for (const node of this.nodes[0].children) {
      for (const entry of node.children) {
        entry.rule.description = node.name;
        const rule = JSON.parse(JSON.stringify(entry.rule));
        if (rule.useStroke === false) {
          rule.stroke = 'trans';
        }
        if (rule.useFill === false) {
          rule.fill = 'trans';
        }
        if (rule.useLabelStyle === false) {
          rule.labelStyle = '';
        }
        this.classification.classes.push(rule);

      }
    }
  }
  Save() {
    this.modified = false;
    this.messager.Progress('Saving classificaiton', false, .5);
    this.NodesToClasses();

    this.classes.SaveProjectLayerClasses(this.layer, this.classification).then((classification) => {
      this.messager.Progress('Saving classificaiton', false, .75);
      this.classification = classification;
      for (const key in this.classification) {
        if (this.classification.hasOwnProperty(key)) {
          const value = this.classification[key];
          switch (key) {
            case 'stroke':
              this.layer.data.classification.stroke_color = value;
              break;
            case 'fill':
              this.layer.data.classification.fill_color = value;
              break;
            case 'size':
              this.layer.data.classification.symbol_size = value;
              break;
            default:
              if (this.layer.data.classification.hasOwnProperty(key)) {
                this.layer.data.classification[key] = value;
              }
              break;
          }
        }
      }
      this.nodes[0].children = [];
      this.tree?.treeModel?.update();

      setTimeout(() => {
        this.SetNodes();
        this.layer.Touch();
        this.layer.Render();
        this.layer.SLMap.RenderResults();
        this.layer.UpdateLegend();
        this.messager.Progress('Saving Layer Styles', true, 1);

      }, 250);
    });


  }
  HandleSymbolSelection(criteriaNode, styleNode: ClassCriteriaDisplayData) {
    this.UpdateCriteriaNode(criteriaNode);
    if (styleNode.rule.symbol === 'custom') {
      this.customSymbols.Show((size: string) => {
        styleNode.rule.size = size;
        this.cdr.markForCheck();
        this.Refresh();
      })
    }
  }
  UpdateCriteriaNode(node: any) {
    this.modified = true;
    let ctr = 0;
    for (const subNode of node.children) {
      subNode.crid = node.crid + ':' + ctr;
      subNode.rule.description = node.name;
      subNode.rule.field = node.field;
      subNode.rule.operator = node.operator;
      subNode.rule.value = node.value;
      ctr++;
    }

  }
  UpdateHeight(height: number) {
    this.domNode.nativeElement.style.setProperty('--panel-height', height + 'px');
    // this.domNode.nativeElement.style.height = height + 'px';

  }
  /*HandleNodeActivation(event: any) {
    if (event.node.id === this.nodes[0].id) {
      return;
    }
    this.activeNodeInfo.nodeId = event.node.id;
    this.activeNodeInfo.hasChildren = event.node.hasChildren;
    this.hasActiveNode = true;
  }
  HandleNodeDeactivation(event: any) {
    if (this.activeNodeInfo.nodeId === event.node.id) {
      this.activeNodeInfo.nodeId = -1;
      this.activeNodeInfo.hasChildren = false;
      this.hasActiveNode = false;
      event.treeModel.setFocusedNode(null);
    }
  }*/
  AllowDrag(node) {
    if (!node.allowDrag()) return false;
    return !this._editing;
    return true;
  }
  _editing = false;
  NoDrag(mode: 'blur' | 'focus') {
    switch (mode) {
      case 'blur':
        this._editing = false;
        break;
      case 'focus':
        this._editing = true;
        break;
    }

  }


  ToggleNodeExpansion(criteriaNode: ClassCriteriaDisplayData, isExpanded?: boolean) {
    if (isExpanded === undefined) {
      isExpanded = !criteriaNode.isExpanded;
    }
    criteriaNode.isExpanded = isExpanded;
    this.Refresh();
  }
  GetSizes() {
    return this.syms.GetSymbolSizeProvider();
  }
  SizeChanged(size: string, rule: ClassColorRule) {
    if (rule.symbol === 'custom') {
      rule.size = size;
    }
    this.Refresh();
  }
  HandleModelChange(event) {
    console.log(event);
  }
  HandleDrop(node, event) {
    console.log('event', event);
    console.log('node', node);
  }
  IsActiveNode(node: any): boolean {
    if (!node) return false;
    if (!this.activeNodeInfo) return false;
    return (this.activeNodeInfo.crid === node?.crid);
  }
  LabelStylesChecked(styleNode: any) {
    return !!styleNode.rule.useLabelStyle ? 'true' : null;
  }
  LabelStyleChange(styleNode: any, event: any) {
    event.preventDefault();
    event.stopImmediatePropagation();

    for (const classification of this.nodes[0].children) {
      for (const style of classification.children) {
        if (style.crid === styleNode.crid) {
          style.rule.useLabelStyle = (event.target.checked === 'checked');// === 'use-label-style');
        }

      }
    }
    this.cdr.markForCheck();
    this.Refresh();
  }
  Refresh() {
    if (!!this._ready) {
      this.cdr.detectChanges();
    }
  }


}
